import { hasOwnProperty, toTitleCase } from '../../tn.common';
import { OPENTYPE_FEATURES } from '../../tn.common/constants/OPENTYPE_FEATURES';
import { titleCase } from '../../tn.ui/module.tn.ui';

const quoteRemover = /['"]/g;
const underscoreReplacer = /_/g;
const altNumberFinder = /\s+(\d+)$/;

export function getOpenTypeFeatureDescription(
    key?: string,
    appendShortcode = true
): string {
    // console.log('getOpenTypeFeatureDescription', key, appendShortcode);
    // if we're empty there's not much of a description there huh?
    if (!key) {
        return '';
    }
    // strip quotes.
    key = key.replace(quoteRemover, '');

    const keyParts = key.split(',');
    const descriptionParts = keyParts.map((subkey) => {
        let altNumber = 1;
        subkey = subkey.trim();
        const altMatch = subkey.match(altNumberFinder);
        if (altMatch) {
            altNumber = parseInt(altMatch[1]);
            subkey = subkey.replace(altNumberFinder, '');
        }

        // if this is an otFeature shortcode ...
        if (hasOwnProperty(OPENTYPE_FEATURES, subkey)) {
            // resolve to full description, apply titlecase and append the shortcode
            let resolved = toTitleCase(OPENTYPE_FEATURES[subkey]);

            if (appendShortcode) {
                if (altNumber > 1) {
                    resolved += ` (${subkey} ${altNumber})`;
                } else {
                    resolved += ` (${subkey})`;
                }
            }
            return resolved;
        }
        // at _least_ strip the quotes, underscores and title case for me!
        toTitleCase(subkey.replace(underscoreReplacer, ' '));
    });
    const description = descriptionParts.join(', ');
    // console.log(description);
    return description;
}

otFeatureDescription.$inject = [];
export function otFeatureDescription() {
    const quoteRemover = /['"]/g;
    const underscoreReplacer = /_/g;
    const altNumberFinder = /\s+(\d+)$/;
    return function otFeatureDescriptionFilter(key, appendShortcode = true) {
        // if we're empty there's not much of a description there huh?
        if (!key) {
            return '';
        }

        key = key.replace(quoteRemover, '');
        return key
            .split(',')
            .map((subkey) => {
                let altNumber = 1;
                subkey = subkey.trim();
                const altMatch = subkey.match(altNumberFinder);
                if (altMatch) {
                    altNumber = parseInt(altMatch[1]);
                    subkey = subkey.replace(altNumberFinder, '');
                }

                // if this is an otFeature shortcode ...
                if (hasOwnProperty(OPENTYPE_FEATURES, subkey)) {
                    // resolve to full description, apply titlecase and append the shortcode
                    let resolved = titleCase(OPENTYPE_FEATURES[subkey]);
                    if (appendShortcode) {
                        if (altNumber > 1) {
                            resolved += ` (${subkey} ${altNumber})`;
                        } else {
                            resolved += ` (${subkey})`;
                        }
                    }
                    return resolved;
                }
                // at _least_ strip the quotes, underscores and title case for me!
                return titleCase(subkey.replace(underscoreReplacer, ' '));
            })
            .join(', ');
    };
}
